import { createFileRoute } from "@tanstack/react-router";
import { EmailSentScreen } from "#app/components/auth/email-sent-screen";
import { resendVerification } from "#app/lib/auth-service";

function VerifyEmailSentScreen() {
  const { email } = Route.useSearch();
  return (
    <EmailSentScreen
      subheading={`We've sent a verification link to ${email || "your email address"}`}
      onResend={email ? () => resendVerification(email) : undefined}
    />
  );
}

export const Route = createFileRoute("/(auth)/verify-email-sent")({
  validateSearch: (search: Record<string, unknown>): { email: string } => ({
    email: typeof search.email === "string" ? search.email : "",
  }),
  component: VerifyEmailSentScreen,
});
